import { useEffect, useState, useRef } from 'react';
import api from '../api/axios';
import styles from './AdminPage.module.css';

export default function AdminPage() {
  const [seccion, setSeccion] = useState('dashboard');
  return (
    <div className={styles.page}>
      <div className={styles.adminNav}>
        <span className={styles.adminBadge}>🛡️ Panel de Administración</span>
        <div className={styles.navTabs}>
          {[
            {key:'dashboard',  label:'📊 Dashboard'},
            {key:'usuarios',   label:'👥 Usuarios'},
            {key:'asignaturas',label:'📚 Asignaturas'},
            {key:'carreras',   label:'🎓 Carreras'},
            {key:'informes',   label:'📈 Informes'},
            {key:'soporte',    label:'🎧 Soporte'},
          ].map(s => (
            <button key={s.key}
              className={`${styles.navTab} ${seccion===s.key ? styles.navTabActive : ''}`}
              onClick={() => setSeccion(s.key)}>
              {s.label}
            </button>
          ))}
        </div>
      </div>
      {seccion==='dashboard'   && <AdminDashboard />}
      {seccion==='usuarios'    && <AdminUsuarios />}
      {seccion==='asignaturas' && <AdminAsignaturas />}
      {seccion==='carreras'    && <AdminCarreras />}
      {seccion==='informes'    && <AdminInformes />}
      {seccion==='soporte'     && <AdminSoporte />}
    </div>
  );
}

// ── Donut chart reutilizable ──────────────────────────────────
function DonutChart({ data, size = 160, stroke = 28 }) {
  const r     = (size - stroke) / 2;
  const circ  = 2 * Math.PI * r;
  const total = data.reduce((s, d) => s + d.value, 0);
  let offset  = 0;
  return (
    <svg width={size} height={size} style={{ transform:'rotate(-90deg)' }}>
      {data.map((d, i) => {
        const pct  = total > 0 ? d.value / total : 0;
        const dash = pct * circ;
        const gap  = circ - dash;
        const el   = (
          <circle key={i} cx={size/2} cy={size/2} r={r}
            fill="none" stroke={d.color} strokeWidth={stroke}
            strokeDasharray={`${dash} ${gap}`}
            strokeDashoffset={-offset} />
        );
        offset += dash;
        return el;
      })}
    </svg>
  );
}

// ── Dashboard ─────────────────────────────────────────────────
function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get('/admin/dashboard').then(r => setStats(r.data.data)); }, []);
  if (!stats) return <p className={styles.loading}>Cargando...</p>;
  return (
    <div>
      <div className={styles.statsGrid}>
        {[
          {icon:'👥', label:'Activos',        valor:stats.usuarios.total,          color:'#1a3a6b'},
          {icon:'👨‍🏫',label:'Profesores',     valor:stats.usuarios.profesors,      color:'#2d527a'},
          {icon:'👩‍🎓',label:'Alumnos',        valor:stats.usuarios.alumnos,        color:'#0f2444'},
          {icon:'🎓', label:'Carreras',        valor:stats.carreras,                color:'#c9a84c'},
          {icon:'📚', label:'Asignaturas',     valor:stats.asignaturas,             color:'#2d7a4f'},
          {icon:'📝', label:'Trabajos',        valor:stats.trabajos,                color:'#1a3a6b'},
          {icon:'📥', label:'Entregas',        valor:stats.entregas,                color:'#c07a1a'},
          {icon:'⭐', label:'Calificaciones',  valor:stats.calificaciones,          color:'#2d527a'},
        ].map((s,i) => (
          <div key={i} className={styles.statCard} style={{'--sc':s.color}}>
            <span className={styles.statIcon}>{s.icon}</span>
            <p className={styles.statValor}>{s.valor ?? 0}</p>
            <p className={styles.statLabel}>{s.label}</p>
          </div>
        ))}
      </div>
      <div className={styles.dashPanels}>
        <div className={styles.dashPanel}>
          <h3 className={styles.panelTitle}>⏰ Últimas entregas</h3>
          {!stats.actividad_reciente?.length ? <p className={styles.panelEmpty}>Sin actividad.</p> : (
            <div className={styles.actList}>
              {stats.actividad_reciente.map((a, i) => (
                <div key={i} className={styles.actItem}>
                  <div className={styles.actAvatar}>{a.nombre[0]}{a.apellidos[0]}</div>
                  <div>
                    <p className={styles.actNombre}>{a.nombre} {a.apellidos}</p>
                    <p className={styles.actDetalle}>{a.trabajo} · {a.asignatura}</p>
                  </div>
                  <span className={styles.actFecha}>{new Date(a.created_at).toLocaleDateString('es-ES')}</span>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className={styles.dashPanel}>
          <h3 className={styles.panelTitle}>🏆 Asignaturas con más alumnos</h3>
          {stats.top_asignaturas?.map((a, i) => (
            <div key={i} className={styles.topItem}>
              <span className={styles.topNum}>{i+1}</span>
              <div className={styles.topInfo}>
                <p className={styles.topNombre}>{a.nombre}</p>
                <p className={styles.topCodigo}>{a.codigo}</p>
              </div>
              <span className={styles.topValor}>{a.total_alumnos} alumnos</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── Usuarios ──────────────────────────────────────────────────
function AdminUsuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [carreras, setCarreras] = useState([]);
  const [filtro,   setFiltro]   = useState('todos');
  const [busqueda, setBusqueda] = useState('');
  const [modal,    setModal]    = useState(null);
  const [detalle,  setDetalle]  = useState(null);
  const empty = {nombre:'',apellidos:'',email:'',password:'',rol:'alumno',dni:'',fecha_nacimiento:'',calle:'',codigo_postal:'',provincia:'',pais:'España',carrera_id:'',carreras:[]};
  const [form,    setForm]    = useState(empty);
  const [saving,  setSaving]  = useState(false);
  const [msg,     setMsg]     = useState('');

  const cargar = () => api.get('/admin/usuarios').then(r => setUsuarios(r.data.data));
  useEffect(() => { cargar(); api.get('/carreras').then(r => setCarreras(r.data.data)); }, []);

  const normalizar = str => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

  const filtrados = usuarios.filter(u => {
    const matchRol  = filtro === 'todos' || u.rol === filtro;
    const matchBusq = !busqueda || normalizar(`${u.nombre} ${u.apellidos} ${u.email}`).includes(normalizar(busqueda));
    return matchRol && matchBusq;
  });

  const abrirEditar = async (u) => {
    const base = {nombre:u.nombre||'',apellidos:u.apellidos||'',email:u.email||'',password:'',rol:u.rol,dni:u.dni||'',fecha_nacimiento:u.fecha_nacimiento||'',calle:u.calle||'',codigo_postal:u.codigo_postal||'',provincia:u.provincia||'',pais:u.pais||'España',carrera_id:u.carrera_id||'',carreras:[]};
    if (u.rol === 'profesor') {
      const r = await api.get(`/admin/usuarios/${u.id}`);
      base.carreras = r.data.data.carreras_profesor?.map(c => c.id) || [];
    }
    setForm(base); setModal({usuario:u}); setMsg('');
  };

  const guardar = async e => {
    e.preventDefault(); setSaving(true); setMsg('');
    try {
      const p = {...form}; if (!p.password) delete p.password; if (!p.carrera_id) p.carrera_id = null;
      if (modal === 'crear') await api.post('/admin/usuarios', p);
      else await api.post(`/admin/usuarios/${modal.usuario.id}`, {...p, _method:'PUT'});
      setMsg('✓ Guardado'); cargar(); setTimeout(() => setModal(null), 1200);
    } catch (err) { setMsg(err.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  const toggleActivo = async (u) => {
    if (u.is_master) { alert('El usuario Master no puede ser desactivado.'); return; }
    if (!window.confirm(`¿${u.activo ? 'Desactivar' : 'Activar'} a ${u.nombre}?`)) return;
    if (u.activo) await api.post(`/admin/usuarios/${u.id}`, { _method:'DELETE' });
    else await api.post(`/admin/usuarios/${u.id}/activar`);
    cargar();
  };

  const verDetalle = async (u) => { const r = await api.get(`/admin/usuarios/${u.id}`); setDetalle(r.data.data); };
  const togCarr    = (id) => setForm(p => ({...p, carreras: p.carreras.includes(id) ? p.carreras.filter(c => c !== id) : [...p.carreras, id]}));
  const rolColor   = r => ({admin:'#c9a84c', profesor:'#1a3a6b', alumno:'#2d7a4f'}[r] || '#666');

  return (
    <div>
      <div className={styles.controls}>
        <input className={styles.searchInput} placeholder="🔍 Buscar..." value={busqueda} onChange={e => setBusqueda(e.target.value)} />
        <div className={styles.filterBtns}>
          {[{key:'todos',label:'Todos'},{key:'alumno',label:'Alumnos'},{key:'profesor',label:'Profesores'},{key:'admin',label:'Administradores'}].map(f => (
            <button key={f.key} className={`${styles.filterBtn} ${filtro===f.key ? styles.filterActive : ''}`} onClick={() => setFiltro(f.key)}>{f.label}</button>
          ))}
        </div>
        <button className={styles.btnNew} onClick={() => { setForm(empty); setModal('crear'); setMsg(''); }}>+ Nuevo usuario</button>
      </div>

      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead><tr><th>Avatar</th><th>Nombre</th><th>Email</th><th>Rol</th><th>Carrera</th><th>Asignaturas</th><th>Estado</th><th>Acciones</th></tr></thead>
          <tbody>
            {filtrados.map(u => (
              <tr key={u.id} className={!u.activo ? styles.rowInactivo : ''}>
                <td>
                  {u.avatar_url
                    ? <img src={u.avatar_url} alt="" className={styles.tableAvatar} />
                    : <div className={styles.tableAvatarIniciales}>{u.nombre?.[0]}{u.apellidos?.[0]}</div>
                  }
                </td>
                <td>
                  <strong>{u.apellidos}, {u.nombre}</strong>
                  {u.is_master == 1 && <span className={styles.masterBadge}>⭐ Master</span>}
                </td>
                <td className={styles.emailCell}>{u.email}</td>
                <td><span className={styles.rolBadge} style={{'--rc':rolColor(u.rol)}}>{u.rol}</span></td>
                <td className={styles.emailCell}>{u.carrera_nombre || '—'}</td>
                <td className={styles.centerCell}>{u.total_asignaturas}</td>
                <td><span className={u.activo ? styles.activoSi : styles.activoNo}>{u.activo ? '✅ Activo' : '🔴 Inactivo'}</span></td>
                <td>
                  <div className={styles.rowActions}>
                    <button className={styles.btnAccion} onClick={() => verDetalle(u)}>👁 Ver</button>
                    <button className={styles.btnAccion} onClick={() => abrirEditar(u)}>✏️ Editar</button>
                    {!u.is_master && (
                      <button className={`${styles.btnAccion} ${u.activo ? styles.btnDes : styles.btnAct}`} onClick={() => toggleActivo(u)}>
                        {u.activo ? '🔒 Desactivar' : '🔓 Activar'}
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal crear/editar */}
      {modal && (
        <div className={styles.overlay} onClick={() => setModal(null)}>
          <div className={styles.modalBoxWide} onClick={e => e.stopPropagation()}>
            <h3 className={styles.modalTitle}>{modal==='crear' ? '➕ Nuevo usuario' : `✏️ Editar: ${modal.usuario?.nombre} ${modal.usuario?.apellidos}`}</h3>
            <form onSubmit={guardar} className={styles.modalForm}>
              <p className={styles.formSection}>🔐 Datos de acceso</p>
              <div className={styles.formRow3}>
                <label className={styles.label}>Nombre<input className={styles.input} value={form.nombre} onChange={e => setForm(p => ({...p,nombre:e.target.value}))} required /></label>
                <label className={styles.label}>Apellidos<input className={styles.input} value={form.apellidos} onChange={e => setForm(p => ({...p,apellidos:e.target.value}))} required /></label>
                <label className={styles.label}>Rol
                  <select className={styles.input} value={form.rol} onChange={e => setForm(p => ({...p,rol:e.target.value}))}>
                    <option value="alumno">Alumno</option>
                    <option value="profesor">Profesor</option>
                    <option value="admin">Administrador</option>
                  </select>
                </label>
              </div>
              <div className={styles.formRow}>
                <label className={styles.label}>Email<input className={styles.input} type="email" value={form.email} onChange={e => setForm(p => ({...p,email:e.target.value}))} required /></label>
                <label className={styles.label}>{modal==='crear' ? 'Contraseña' : 'Nueva contraseña (vacío = no cambiar)'}<input className={styles.input} type="password" value={form.password} onChange={e => setForm(p => ({...p,password:e.target.value}))} required={modal==='crear'} /></label>
              </div>
              <p className={styles.formSection}>📋 Datos personales</p>
              <div className={styles.formRow3}>
                <label className={styles.label}>DNI / NIF<input className={styles.input} value={form.dni} onChange={e => setForm(p => ({...p,dni:e.target.value}))} /></label>
                <label className={styles.label}>Fecha nacimiento<input className={styles.input} type="date" value={form.fecha_nacimiento} onChange={e => setForm(p => ({...p,fecha_nacimiento:e.target.value}))} /></label>
                <label className={styles.label}>Código postal<input className={styles.input} value={form.codigo_postal} onChange={e => setForm(p => ({...p,codigo_postal:e.target.value}))} /></label>
              </div>
              <div className={styles.formRow}>
                <label className={styles.label}>Calle / Dirección<input className={styles.input} value={form.calle} onChange={e => setForm(p => ({...p,calle:e.target.value}))} /></label>
                <label className={styles.label}>Provincia<input className={styles.input} value={form.provincia} onChange={e => setForm(p => ({...p,provincia:e.target.value}))} /></label>
              </div>
              <label className={styles.label} style={{maxWidth:'220px'}}>País<input className={styles.input} value={form.pais} onChange={e => setForm(p => ({...p,pais:e.target.value}))} /></label>
              <p className={styles.formSection}>🎓 Carrera universitaria</p>
              {form.rol==='alumno' && (
                <label className={styles.label} style={{maxWidth:'400px'}}>Carrera
                  <select className={styles.input} value={form.carrera_id} onChange={e => setForm(p => ({...p,carrera_id:e.target.value}))}>
                    <option value="">Sin carrera</option>
                    {carreras.map(c => <option key={c.id} value={c.id}>{c.nombre} ({c.codigo})</option>)}
                  </select>
                </label>
              )}
              {form.rol==='profesor' && (
                <div>
                  <p className={styles.label}>Carreras en las que imparte</p>
                  <div className={styles.carrerasCheck}>
                    {carreras.map(c => (
                      <label key={c.id} className={styles.checkItem}>
                        <input type="checkbox" checked={form.carreras.includes(c.id)} onChange={() => togCarr(c.id)} />
                        <span>{c.nombre} <span className={styles.checkRol}>({c.codigo})</span></span>
                      </label>
                    ))}
                  </div>
                </div>
              )}
              {msg && <p className={msg.startsWith('✓') ? styles.success : styles.errorMsg}>{msg}</p>}
              <div className={styles.modalActions}>
                <button type="button" className={styles.btnCancel} onClick={() => setModal(null)}>Cancelar</button>
                <button type="submit" className={styles.btnGuardar} disabled={saving}>{saving ? 'Guardando...' : '💾 Guardar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal detalle */}
      {detalle && (
        <div className={styles.overlay} onClick={() => setDetalle(null)}>
          <div className={styles.modalBox} onClick={e => e.stopPropagation()}>
            <div style={{padding:'1.5rem', overflowY:'auto', flex:1}}>
            <div className={styles.detalleTop}>
              {detalle.avatar_url
                ? <img src={detalle.avatar_url} alt="" className={styles.detalleAvatar} />
                : <div className={styles.detalleAvatarIniciales}>{detalle.nombre?.[0]}{detalle.apellidos?.[0]}</div>
              }
              <div>
                <h3 className={styles.modalTitle} style={{padding:0}}>{detalle.nombre} {detalle.apellidos}</h3>
                <p className={styles.modalSub} style={{padding:0}}>{detalle.email} · {detalle.rol}</p>
                {detalle.is_master == 1 && <span className={styles.masterBadge}>⭐ Master</span>}
              </div>
            </div>
            <div className={styles.detalleGrid}>
              {[['DNI',detalle.dni],['Fecha nac.',detalle.fecha_nacimiento?new Date(detalle.fecha_nacimiento).toLocaleDateString('es-ES'):null],['Dirección',detalle.calle],['C.P.',detalle.codigo_postal],['Provincia',detalle.provincia],['País',detalle.pais],['Carrera',detalle.carrera_nombre]].map(([l,v]) => (
                <div key={l} className={styles.detalleItem}><span className={styles.detalleLabel}>{l}</span><span className={styles.detalleValor}>{v || '—'}</span></div>
              ))}
            </div>
            {detalle.carreras_profesor?.length > 0 && (
              <div style={{marginTop:'1rem'}}>
                <p className={styles.detalleLabel}>Carreras:</p>
                <div style={{display:'flex',gap:'.4rem',flexWrap:'wrap',marginTop:'.4rem'}}>
                  {detalle.carreras_profesor.map(c => <span key={c.id} className={styles.carreraBadge}>{c.nombre}</span>)}
                </div>
              </div>
            )}
            <h4 className={styles.detalleSeccion}>Asignaturas ({detalle.asignaturas?.length})</h4>
            <div className={styles.asigList}>
              {detalle.asignaturas?.map(a => (
                <div key={a.id} className={styles.asigItem}>
                  <span className={styles.asigCodigo}>{a.codigo}</span>
                  <span>{a.nombre}</span>
                  <span className={styles.asigCurso}>Curso {a.curso}º</span>
                </div>
              ))}
            </div>
            <button className={styles.btnCancel} style={{marginTop:'1rem'}} onClick={() => setDetalle(null)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Asignaturas ───────────────────────────────────────────────
function AdminAsignaturas() {
  const [asignaturas,setAsignaturas]=useState([]);const [carreras,setCarreras]=useState([]);
  const [modal,setModal]=useState(null);const [matricModal,setMatricModal]=useState(null);
  const [todosUsuarios,setTodosUsuarios]=useState([]);const [usuariosAsig,setUsuariosAsig]=useState([]);
  const [selAlumnos,setSelAlumnos]=useState([]);const [selProfesores,setSelProfesores]=useState([]);
  const [busqAlumnos,setBusqAlumnos]=useState('');const [busqProfesores,setBusqProfesores]=useState('');
  const [form,setForm]=useState({codigo:'',nombre:'',descripcion:'',curso:'1',cuatrimestre:'1',carrera_id:''});
  const [saving,setSaving]=useState(false);const [msg,setMsg]=useState('');
  const normalizar=str=>str.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  const cargar=()=>api.get('/admin/asignaturas').then(r=>setAsignaturas(r.data.data));
  useEffect(()=>{cargar();api.get('/carreras').then(r=>setCarreras(r.data.data));},[]);
  const guardar=async e=>{
    e.preventDefault();setSaving(true);setMsg('');
    try{
      if(modal==='crear')await api.post('/admin/asignaturas',form);
      else await api.post(`/admin/asignaturas/${modal.id}`,{...form,_method:'PUT'});
      setMsg('✓ Guardado');cargar();setTimeout(()=>setModal(null),1200);
    }catch(err){setMsg(err.response?.data?.error||'Error');}finally{setSaving(false);}
  };
  const abrirGestion=async(asig)=>{
    setMatricModal(asig);setSelAlumnos([]);setSelProfesores([]);setBusqAlumnos('');setBusqProfesores('');
    const [r1,r2]=await Promise.all([api.get('/admin/usuarios'),api.get(`/admin/asignaturas/${asig.id}/usuarios`)]);
    setTodosUsuarios(r1.data.data.filter(u=>u.rol!=='admin'));setUsuariosAsig(r2.data.data);
  };
  const asignar=async(sel,reset)=>{
    if(!sel.length)return;
    await api.post(`/admin/asignaturas/${matricModal.id}/matricular`,{usuarios:sel});
    const r=await api.get(`/admin/asignaturas/${matricModal.id}/usuarios`);
    setUsuariosAsig(r.data.data);reset([]);cargar();
  };
  const desasignar=async(userId)=>{
    await api.post(`/admin/asignaturas/${matricModal.id}/usuarios/${userId}`,{_method:'DELETE'});
    setUsuariosAsig(prev=>prev.filter(u=>u.id!==userId));cargar();
  };
  const yaAsignados=new Set(usuariosAsig.map(u=>u.id));
  const noAsignadosAlumnos=todosUsuarios.filter(u=>u.rol==='alumno'&&!yaAsignados.has(u.id)&&
    (!busqAlumnos||normalizar(`${u.nombre} ${u.apellidos} ${u.email}`).includes(normalizar(busqAlumnos))));
  const noAsignadosProfesores=todosUsuarios.filter(u=>u.rol==='profesor'&&!yaAsignados.has(u.id)&&
    (!busqProfesores||normalizar(`${u.nombre} ${u.apellidos} ${u.email}`).includes(normalizar(busqProfesores))));
  const rolColor=r=>({alumno:'#2d7a4f',profesor:'#1a3a6b'}[r]||'#888');
  return (
    <div>
      <div className={styles.controls}><button className={styles.btnNew} onClick={()=>{setForm({codigo:'',nombre:'',descripcion:'',curso:'1',cuatrimestre:'1',carrera_id:''});setModal('crear');setMsg('');}}>+ Nueva asignatura</button></div>
      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead><tr><th>Código</th><th>Nombre</th><th>Carrera</th><th>Curso</th><th>Alumnos</th><th>Profesores</th><th>Estado</th><th>Acciones</th></tr></thead>
          <tbody>
            {asignaturas.map(a=>(
              <tr key={a.id} className={!a.activa?styles.rowInactivo:''}>
                <td><span className={styles.asigCodigoBadge}>{a.codigo}</span></td>
                <td><strong>{a.nombre}</strong></td>
                <td className={styles.emailCell}>{a.carrera_nombre||'—'}</td>
                <td>{a.curso}º · C{a.cuatrimestre}</td>
                <td className={styles.centerCell}>{a.total_alumnos??0}</td>
                <td className={styles.centerCell}>{a.total_profesores??0}</td>
                <td><span className={a.activa?styles.activoSi:styles.activoNo}>{a.activa?'✅ Activa':'🔴 Inactiva'}</span></td>
                <td><div className={styles.rowActions}>
                  <button className={styles.btnAccion} onClick={()=>{setForm({codigo:a.codigo,nombre:a.nombre,descripcion:a.descripcion||'',curso:String(a.curso),cuatrimestre:String(a.cuatrimestre),activa:a.activa,carrera_id:a.carrera_id||''});setModal(a);setMsg('');}}>✏️ Editar</button>
                  <button className={styles.btnAccion} onClick={()=>abrirGestion(a)}>👥 Gestionar</button>
                </div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal crear/editar asignatura */}
      {modal&&(<div className={styles.overlay} onClick={()=>setModal(null)}><div className={styles.modalBox} onClick={e=>e.stopPropagation()}><h3 className={styles.modalTitle}>{modal==='crear'?'Nueva asignatura':`Editar: ${modal.nombre}`}</h3><form onSubmit={guardar} className={styles.modalForm}><div className={styles.formRow}><label className={styles.label}>Código<input className={styles.input} value={form.codigo} onChange={e=>setForm(p=>({...p,codigo:e.target.value}))} required /></label><label className={styles.label}>Nombre<input className={styles.input} value={form.nombre} onChange={e=>setForm(p=>({...p,nombre:e.target.value}))} required /></label></div><label className={styles.label}>Descripción<textarea className={styles.textarea} rows="2" value={form.descripcion} onChange={e=>setForm(p=>({...p,descripcion:e.target.value}))} /></label><div className={styles.formRow3}><label className={styles.label}>Curso<select className={styles.input} value={form.curso} onChange={e=>setForm(p=>({...p,curso:e.target.value}))}>{[1,2,3,4].map(c=><option key={c} value={c}>{c}º</option>)}</select></label><label className={styles.label}>Cuatrimestre<select className={styles.input} value={form.cuatrimestre} onChange={e=>setForm(p=>({...p,cuatrimestre:e.target.value}))}><option value="1">1º</option><option value="2">2º</option></select></label><label className={styles.label}>Carrera<select className={styles.input} value={form.carrera_id} onChange={e=>setForm(p=>({...p,carrera_id:e.target.value}))}><option value="">Sin carrera</option>{carreras.map(c=><option key={c.id} value={c.id}>{c.nombre}</option>)}</select></label></div>{modal!=='crear'&&<label className={styles.checkLabel}><input type="checkbox" checked={!!form.activa} onChange={e=>setForm(p=>({...p,activa:e.target.checked?1:0}))} /> Activa</label>}{msg&&<p className={msg.startsWith('✓')?styles.success:styles.errorMsg}>{msg}</p>}<div className={styles.modalActions}><button type="button" className={styles.btnCancel} onClick={()=>setModal(null)}>Cancelar</button><button type="submit" className={styles.btnGuardar} disabled={saving}>{saving?'Guardando...':'Guardar'}</button></div></form></div></div>)}

      {/* Modal gestión alumnos/profesores */}
      {matricModal&&(
        <div className={styles.overlay} onClick={()=>setMatricModal(null)}>
          <div className={styles.modalBoxWide} onClick={e=>e.stopPropagation()}>
            <h3 className={styles.modalTitle}>👥 Gestionar usuarios — {matricModal.nombre}</h3>
            <div className={styles.gestionLayout}>

              {/* Panel izquierdo: Matricular alumnos */}
              <div className={styles.gestionPanel}>
                <h4 className={styles.gestionPanelTitle}>🎓 Matricular alumnos</h4>
                <input
                  className={styles.gestionSearch}
                  placeholder="🔍 Buscar alumno..."
                  value={busqAlumnos}
                  onChange={e=>setBusqAlumnos(e.target.value)}
                />
                <div className={styles.gestionList}>
                  {noAsignadosAlumnos.length===0
                    ? <p className={styles.panelEmpty}>{busqAlumnos?'Sin resultados.':'Todos los alumnos ya matriculados.'}</p>
                    : noAsignadosAlumnos.map(u=>(
                      <label key={u.id} className={styles.checkItem}>
                        <input type="checkbox" checked={selAlumnos.includes(u.id)}
                          onChange={()=>setSelAlumnos(prev=>prev.includes(u.id)?prev.filter(i=>i!==u.id):[...prev,u.id])} />
                        <div className={styles.checkAvatar}>{u.nombre[0]}{u.apellidos[0]}</div>
                        <div><p className={styles.checkNombre}>{u.nombre} {u.apellidos}</p>
                          <p className={styles.checkRol}>{u.email}</p></div>
                      </label>
                    ))
                  }
                </div>
                <button className={styles.btnGuardar} disabled={!selAlumnos.length}
                  onClick={()=>asignar(selAlumnos,setSelAlumnos)}>
                  ➕ Matricular ({selAlumnos.length})
                </button>
              </div>

              {/* Panel central: Asignar profesores */}
              <div className={styles.gestionPanel}>
                <h4 className={styles.gestionPanelTitle}>👨‍🏫 Asignar profesores</h4>
                <input
                  className={styles.gestionSearch}
                  placeholder="🔍 Buscar profesor..."
                  value={busqProfesores}
                  onChange={e=>setBusqProfesores(e.target.value)}
                />
                <div className={styles.gestionList}>
                  {noAsignadosProfesores.length===0
                    ? <p className={styles.panelEmpty}>{busqProfesores?'Sin resultados.':'Todos los profesores ya asignados.'}</p>
                    : noAsignadosProfesores.map(u=>(
                      <label key={u.id} className={styles.checkItem}>
                        <input type="checkbox" checked={selProfesores.includes(u.id)}
                          onChange={()=>setSelProfesores(prev=>prev.includes(u.id)?prev.filter(i=>i!==u.id):[...prev,u.id])} />
                        <div className={styles.checkAvatar}>{u.nombre[0]}{u.apellidos[0]}</div>
                        <div><p className={styles.checkNombre}>{u.nombre} {u.apellidos}</p>
                          <p className={styles.checkRol}>{u.email}</p></div>
                      </label>
                    ))
                  }
                </div>
                <button className={styles.btnGuardar} disabled={!selProfesores.length}
                  onClick={()=>asignar(selProfesores,setSelProfesores)}>
                  ➕ Asignar ({selProfesores.length})
                </button>
              </div>

              {/* Panel derecho: Ya asignados */}
              <div className={styles.gestionPanel}>
                <h4 className={styles.gestionPanelTitle}>✅ Ya asignados ({usuariosAsig.length})</h4>
                <div className={styles.gestionList}>
                  {usuariosAsig.length===0
                    ? <p className={styles.panelEmpty}>Sin usuarios asignados.</p>
                    : usuariosAsig.map(u=>(
                      <div key={u.id} className={styles.matricItem}>
                        <div className={styles.checkAvatar}>{u.nombre[0]}{u.apellidos[0]}</div>
                        <div style={{flex:1}}>
                          <p className={styles.checkNombre}>{u.nombre} {u.apellidos}</p>
                          <span className={styles.rolBadge} style={{'--rc':rolColor(u.rol)}}>{u.rol}</span>
                        </div>
                        <button className={styles.btnElim} onClick={()=>desasignar(u.id)}>✕</button>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
            <div style={{padding:'1rem 1.5rem',borderTop:'1px solid var(--border)'}}>
              <button className={styles.btnCancel} onClick={()=>setMatricModal(null)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Carreras ──────────────────────────────────────────────────
function AdminCarreras() {
  const [carreras,setCarreras]=useState([]);const [modal,setModal]=useState(null);
  const [form,setForm]=useState({nombre:'',descripcion:'',codigo:''});const [saving,setSaving]=useState(false);const [msg,setMsg]=useState('');
  const cargar=()=>api.get('/admin/carreras').then(r=>setCarreras(r.data.data));
  useEffect(()=>{cargar();},[]);
  const guardar=async e=>{
    e.preventDefault();setSaving(true);setMsg('');
    try{
      if(modal==='crear')await api.post('/admin/carreras',form);
      else await api.post(`/admin/carreras/${modal.id}`,{...form,_method:'PUT'});
      setMsg('✓ Guardado');cargar();setTimeout(()=>setModal(null),1200);
    }catch(err){setMsg(err.response?.data?.error||'Error');}finally{setSaving(false);}
  };
  return (
    <div>
      <div className={styles.controls}><button className={styles.btnNew} onClick={()=>{setForm({nombre:'',descripcion:'',codigo:''});setModal('crear');setMsg('');}}>+ Nueva carrera</button></div>
      <div className={styles.carrerasGrid}>
        {carreras.map(c=>(<div key={c.id} className={`${styles.carreraCard} ${!c.activa?styles.carreraInactiva:''}`}><div className={styles.carreraHeader}><span className={styles.carreraCodigo}>{c.codigo}</span><span className={c.activa?styles.activoSi:styles.activoNo}>{c.activa?'✅ Activa':'🔴 Inactiva'}</span></div><h3 className={styles.carreraNombre}>{c.nombre}</h3>{c.descripcion&&<p className={styles.carreraDesc}>{c.descripcion}</p>}<div className={styles.carreraStats}><span>📚 {c.total_asignaturas} asignaturas</span><span>👩‍🎓 {c.total_alumnos} alumnos</span><span>👨‍🏫 {c.total_profesores} profesores</span></div><button className={styles.btnAccion} style={{marginTop:'.8rem'}} onClick={()=>{setForm({nombre:c.nombre,descripcion:c.descripcion||'',codigo:c.codigo,activa:c.activa});setModal(c);setMsg('');}}>✏️ Editar</button></div>))}
      </div>
      {modal&&(<div className={styles.overlay} onClick={()=>setModal(null)}><div className={styles.modalBox} onClick={e=>e.stopPropagation()}><h3 className={styles.modalTitle}>{modal==='crear'?'🎓 Nueva carrera':`✏️ Editar: ${modal.nombre}`}</h3><form onSubmit={guardar} className={styles.modalForm}><div className={styles.formRow}><label className={styles.label}>Código<input className={styles.input} value={form.codigo} onChange={e=>setForm(p=>({...p,codigo:e.target.value.toUpperCase()}))} placeholder="GII" required disabled={modal!=='crear'} /></label><label className={styles.label}>Nombre<input className={styles.input} value={form.nombre} onChange={e=>setForm(p=>({...p,nombre:e.target.value}))} required /></label></div><label className={styles.label}>Descripción<textarea className={styles.textarea} rows="2" value={form.descripcion} onChange={e=>setForm(p=>({...p,descripcion:e.target.value}))} /></label>{modal!=='crear'&&<label className={styles.checkLabel}><input type="checkbox" checked={!!form.activa} onChange={e=>setForm(p=>({...p,activa:e.target.checked?1:0}))} /> Activa</label>}{msg&&<p className={msg.startsWith('✓')?styles.success:styles.errorMsg}>{msg}</p>}<div className={styles.modalActions}><button type="button" className={styles.btnCancel} onClick={()=>setModal(null)}>Cancelar</button><button type="submit" className={styles.btnGuardar} disabled={saving}>{saving?'Guardando...':'Guardar'}</button></div></form></div></div>)}
    </div>
  );
}

// ── Informes ──────────────────────────────────────────────────
const DONUT_COLORS = ['#1a3a6b','#c9a84c','#2d7a4f','#c07a1a','#2d527a','#8b1a1a','#1a6b5a','#6b3d1a'];

function AdminInformes() {
  const [datos, setDatos]           = useState(null);
  const [expediente, setExpediente] = useState(null);
  const [loadingExp, setLoadingExp] = useState(false);

  useEffect(() => { api.get('/admin/informes/actividad').then(r => setDatos(r.data.data)); }, []);

  const verExpediente = async (alumno) => {
    setLoadingExp(true);
    try {
      const r = await api.get(`/admin/usuarios/${alumno.id}/expediente`);
      setExpediente(r.data.data);
    } finally { setLoadingExp(false); }
  };

  if (!datos) return <p className={styles.loading}>Cargando...</p>;

  const maxE = Math.max(...datos.entregas_por_asignatura.map(a => a.total_entregas || 0), 1);

  const rolesData    = (datos.distribucion_roles || []).map((r, i) => ({ label: r.rol, value: parseInt(r.total), color: DONUT_COLORS[i] }));
  const carrerasData = (datos.alumnos_por_carrera || []).map((c, i) => ({ label: c.nombre, value: parseInt(c.total_alumnos), color: DONUT_COLORS[i] }));
  const notasRaw     = datos.distribucion_notas || {};
  const notasData    = [
    {label:'Sobresaliente', value:parseInt(notasRaw.sobresaliente||0), color:'#2d7a4f'},
    {label:'Notable',       value:parseInt(notasRaw.notable||0),       color:'#1a3a6b'},
    {label:'Bien',          value:parseInt(notasRaw.bien||0),           color:'#c9a84c'},
    {label:'Aprobado',      value:parseInt(notasRaw.aprobado||0),       color:'#c07a1a'},
    {label:'Suspenso',      value:parseInt(notasRaw.suspenso||0),       color:'#8b1a1a'},
  ].filter(n => n.value > 0);

  const notaColor = n => { if (!n) return 'var(--text-light)'; if (n>=9) return '#2d7a4f'; if (n>=7) return '#1a3a6b'; if (n>=5) return '#c07a1a'; return '#8b1a1a'; };
  const notaLabel = n => { if (!n) return '—'; if (n>=9) return 'Sobresaliente'; if (n>=7) return 'Notable'; if (n>=6) return 'Bien'; if (n>=5) return 'Aprobado'; return 'Suspenso'; };

  return (
    <div>
      <div className={styles.donutsGrid}>
        <DonutCard titulo="👥 Distribución de usuarios" data={rolesData} />
        <DonutCard titulo="🎓 Alumnos por carrera"      data={carrerasData} />
        <DonutCard titulo="⭐ Distribución de notas"    data={notasData} />
      </div>

      <div className={styles.informesGrid}>
        <div className={styles.informePanel}>
          <h3 className={styles.panelTitle}>📥 Entregas por asignatura</h3>
          {datos.entregas_por_asignatura.map((a, i) => (
            <div key={i} className={styles.barItem}>
              <p className={styles.barLabel}>{a.asignatura}</p>
              <div className={styles.barWrap}>
                <div className={styles.barFill}      style={{width:`${((a.total_entregas||0)/maxE)*100}%`}} />
                <div className={styles.barFillCalif} style={{width:`${((a.calificadas||0)/maxE)*100}%`}} />
              </div>
              <span className={styles.barNum}>{a.total_entregas||0} entregas · {a.calificadas||0} cal.</span>
            </div>
          ))}
        </div>

        <div className={styles.informePanel}>
          <h3 className={styles.panelTitle}>🏅 Mejores expedientes</h3>
          <p className={styles.panelSubtitle}>Haz clic para ver el expediente completo</p>
          <table className={styles.tableSmall}>
            <thead><tr><th>Alumno</th><th>Media expediente</th></tr></thead>
            <tbody>
              {(datos.mejores_expedientes || []).slice(0, 10).map((a, i) => (
                <tr key={i} className={styles.trClickable} onClick={() => verExpediente(a)}>
                  <td>
                    <div className={styles.expTableAlumno}>
                      {a.avatar_url
                        ? <img src={a.avatar_url} alt="" className={styles.tableAvatar} />
                        : <div className={styles.tableAvatarIniciales}>{a.nombre?.[0]}{a.apellidos?.[0]}</div>
                      }
                      <span>{a.nombre} {a.apellidos}</span>
                    </div>
                  </td>
                  <td className={styles.centerCell}>
                    <strong style={{color: notaColor(parseFloat(a.media_expediente))}}>
                      {a.media_expediente ? Number(a.media_expediente).toFixed(2) : '—'}
                    </strong>
                  </td>
                </tr>
              ))}
              {(!datos.mejores_expedientes || datos.mejores_expedientes.length === 0) && (
                <tr><td colSpan="2" className={styles.panelEmpty}>Sin datos suficientes.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal expediente */}
      {(expediente || loadingExp) && (
        <div className={styles.overlay} onClick={() => setExpediente(null)}>
          <div className={styles.modalBox} style={{overflow:'hidden'}} onClick={e => e.stopPropagation()}>
            {loadingExp ? (
              <p className={styles.loading} style={{padding:'2rem'}}>Cargando expediente...</p>
            ) : (
              <>
                <div style={{background:'var(--navy)', padding:'1.2rem 1.4rem', display:'flex', alignItems:'center', gap:'1rem'}}>
                  <div style={{display:'flex', alignItems:'center', gap:'1rem', flex:1}}>
                    {expediente.alumno.avatar_url
                      ? <img src={expediente.alumno.avatar_url} alt="" className={styles.detalleAvatar} />
                      : <div className={styles.detalleAvatarIniciales}>{expediente.alumno.nombre?.[0]}{expediente.alumno.apellidos?.[0]}</div>
                    }
                    <div>
                      <h3 style={{fontFamily:'var(--font-display)',fontSize:'1.1rem',color:'var(--white)',margin:0}}>{expediente.alumno.nombre} {expediente.alumno.apellidos}</h3>
                      <p style={{color:'rgba(255,255,255,.7)',fontSize:'.85rem',margin:0}}>{expediente.alumno.email}</p>
                    </div>
                  </div>
                  <button style={{padding:'6px 12px',borderRadius:'6px',background:'rgba(255,255,255,.15)',color:'var(--white)',fontSize:'1rem',fontWeight:'700',flexShrink:0,border:'none',cursor:'pointer'}} onClick={() => setExpediente(null)}>✕</button>
                </div>
                <div className={styles.modalContent}>
                  {expediente.media_general !== null && (
                    <div className={styles.expedienteMediaBox}>
                      <div>
                        <p className={styles.expedienteMediaLabel}>Media general del expediente</p>
                        <p className={styles.expedienteMediaSub}>Media aritmética de las notas ponderadas por asignatura</p>
                      </div>
                      <div className={styles.notaCirculoExp} style={{'--nc': notaColor(parseFloat(expediente.media_general))}}>
                        <span className={styles.notaNumExp}>{Number(expediente.media_general).toFixed(2)}</span>
                        <span className={styles.notaLabelExp}>{notaLabel(parseFloat(expediente.media_general))}</span>
                      </div>
                    </div>
                  )}
                  <h4 className={styles.detalleSeccion}>Notas ponderadas por asignatura</h4>
                  <div className={styles.expAsigList}>
                    {expediente.asignaturas.map((a, i) => (
                      <div key={i} className={styles.expAsigItem}>
                        <div className={styles.expAsigInfo}>
                          <span className={styles.asigCodigo}>{a.codigo}</span>
                          <span className={styles.expAsigNombre}>{a.asignatura}</span>
                          <span className={styles.expAsigPeso}>
                            {a.peso_evaluado > 0 ? `${parseFloat(a.peso_evaluado).toFixed(0)}% evaluado` : 'Sin calificar'}
                          </span>
                        </div>
                        <div className={styles.expNotaBar}>
                          {a.nota_ponderada !== null ? (
                            <>
                              <div className={styles.expBarFill} style={{width:`${(parseFloat(a.nota_ponderada)/10)*100}%`, background: notaColor(parseFloat(a.nota_ponderada))}} />
                              <span className={styles.expBarNota} style={{color: notaColor(parseFloat(a.nota_ponderada))}}>{Number(a.nota_ponderada).toFixed(2)}</span>
                            </>
                          ) : (
                            <span style={{color:'var(--text-light)',fontSize:'.8rem'}}>Sin datos</span>
                          )}
                        </div>
                      </div>
                    ))}
                    {expediente.asignaturas.length === 0 && <p className={styles.panelEmpty}>No hay datos de calificaciones publicadas.</p>}
                  </div>
                </div>
                <div style={{padding:'.8rem 1.4rem', background:'var(--white)', borderRadius:'0 0 var(--radius-lg) var(--radius-lg)'}}>
                  <button className={styles.btnCancel} onClick={() => setExpediente(null)}>Cerrar</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function DonutCard({ titulo, data }) {
  const total = data.reduce((s, d) => s + d.value, 0);
  return (
    <div className={styles.donutCard}>
      <h3 className={styles.panelTitle}>{titulo}</h3>
      <div className={styles.donutWrap}>
        <div className={styles.donutSvg}>
          <DonutChart data={data} size={160} stroke={28} />
          <div className={styles.donutCenter}>
            <span className={styles.donutTotal}>{total}</span>
            <span className={styles.donutTotalLabel}>total</span>
          </div>
        </div>
        <div className={styles.donutLeyenda}>
          {data.map((d, i) => (
            <div key={i} className={styles.leyendaItem}>
              <span className={styles.leyendaDot} style={{background:d.color}} />
              <span className={styles.leyendaLabel}>{d.label}</span>
              <span className={styles.leyendaValor}>{d.value}</span>
              <span className={styles.leyendaPct}>{total > 0 ? Math.round(d.value/total*100) : 0}%</span>
            </div>
          ))}
          {data.length === 0 && <p className={styles.panelEmpty}>Sin datos</p>}
        </div>
      </div>
    </div>
  );
}

// ── Soporte Admin ─────────────────────────────────────────────
function etiquetaFechaSop(fechaStr) {
  const hoy  = new Date();
  const ayer = new Date(); ayer.setDate(ayer.getDate() - 1);
  const f    = new Date(fechaStr);
  const same = (a,b) => a.getFullYear()===b.getFullYear() && a.getMonth()===b.getMonth() && a.getDate()===b.getDate();
  if (same(f,hoy))  return 'Hoy';
  if (same(f,ayer)) return 'Ayer';
  return f.toLocaleDateString('es-ES',{weekday:'long',day:'2-digit',month:'long',year:'numeric'});
}
function claveFechaSop(fechaStr) {
  const d = new Date(fechaStr);
  return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
}

function AdminSoporte() {
  const [chats, setChats]         = useState([]);
  const [selected, setSelected]   = useState(null);
  const [loadingList, setLoadingList] = useState(true);
  const [loadingConv, setLoadingConv] = useState(false);
  const [respuesta, setRespuesta] = useState('');
  const [adjunto, setAdjunto]     = useState(null);
  const [enviando, setEnviando]   = useState(false);
  const endRef     = useRef(null);
  const adjuntoRef = useRef(null);

  const cargarLista = () => {
    setLoadingList(true);
    api.get('/admin/soporte')
      .then(r => {
        console.log('SOPORTE DATA:', r.data.data);
        console.log('ES ARRAY:', Array.isArray(r.data.data));
        console.log('LENGTH:', r.data.data?.length);
        setChats(Array.isArray(r.data.data) ? r.data.data : []);
      })
      .catch(err => {
        console.error('ERROR SOPORTE:', err.response?.status, err.response?.data);
      })
      .finally(() => setLoadingList(false));
  };

  useEffect(() => { cargarLista(); }, []);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior:'smooth' }); }, [selected]);

  const abrirChat = async (chat) => {
    setLoadingConv(true);
    try {
      const r = await api.get(`/admin/soporte/${chat.id}`);
      setSelected(r.data.data);
    } finally { setLoadingConv(false); }
  };

  const enviar = async e => {
    e.preventDefault();
    if (!respuesta.trim() && !adjunto) return;
    setEnviando(true);
    try {
      const fd = new FormData();
      fd.append('contenido', respuesta);
      if (adjunto) fd.append('adjunto', adjunto);
      await api.post(`/admin/soporte/${selected.id}`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setRespuesta('');
      setAdjunto(null);
      if (adjuntoRef.current) adjuntoRef.current.value = '';
      const r = await api.get(`/admin/soporte/${selected.id}`);
      setSelected(r.data.data);
      cargarLista();
    } finally { setEnviando(false); }
  };

  const abrirAdjunto = (msgId, soloUrl = false) => {
    const token = localStorage.getItem('token');
    const url = `https://eduportalual.com/backend/api/x7Kp9mQ2/conversaciones/${selected.id}/adjunto/${msgId}`;
    const full = url + (token ? '?token=' + encodeURIComponent(token) : '');
    if (soloUrl) return full;
    window.open(full, '_blank');
  };

  const formatHora  = d => new Date(d).toLocaleTimeString('es-ES',{hour:'2-digit',minute:'2-digit'});
  const formatFecha = d => new Date(d).toLocaleDateString('es-ES',{day:'2-digit',month:'short'});

  const mensajesConSep = () => {
    const msgs = selected?.mensajes || [];
    const result = []; let ultima = null;
    msgs.forEach(m => {
      const clave = claveFechaSop(m.created_at);
      if (clave !== ultima) { result.push({tipo:'sep', fecha:m.created_at, clave}); ultima = clave; }
      result.push({tipo:'msg', ...m});
    });
    return result;
  };

  return (
    <div className={styles.soporteLayout}>
      {/* Lista de chats */}
      <div className={styles.soporteLista}>
        <h3 className={styles.soporteListaTitulo}>🎧 Chats de soporte</h3>
        {loadingList && <p className={styles.loading}>Cargando...</p>}
        <div className={styles.soporteListaScroll}>
        {!loadingList && chats.length === 0 && (
          <p className={styles.panelEmpty}>Sin chats de soporte aún.</p>
        )}
        {chats.map(chat => (
          <div key={chat.id}
            className={`${styles.soporteChatItem} ${selected?.id === chat.id ? styles.soporteChatActivo : ''}`}
            onClick={() => abrirChat(chat)}>
            <div className={styles.soporteChatAvatar}>
              {chat.avatar_url
                ? <img src={chat.avatar_url} alt="" className={styles.tableAvatar} />
                : <div className={styles.tableAvatarIniciales}>{chat.creador_nombre?.[0]}{chat.creador_apellidos?.[0]}</div>
              }
            </div>
            <div className={styles.soporteChatInfo}>
              <div className={styles.soporteChatTop}>
                <p className={styles.soporteChatNombre}>{chat.creador_nombre} {chat.creador_apellidos}</p>
                <span className={styles.soporteChatFecha}>{formatFecha(chat.updated_at)}</span>
              </div>
              <p className={styles.soporteChatRol}>{chat.creador_rol} · {chat.creador_email}</p>
              {chat.ultimo_mensaje && (
                <p className={styles.soporteChatPreview}>{chat.ultimo_mensaje}</p>
              )}
            </div>
          </div>
        ))}
        </div>
      </div>

      {/* Panel de conversación */}
      <div className={styles.soporteConv}>
        {!selected && !loadingConv && (
          <div className={styles.soporteEmpty}>
            <p style={{fontSize:'2rem'}}>🎧</p>
            <p>Selecciona un chat para responder</p>
          </div>
        )}
        {loadingConv && <p className={styles.loading}>Cargando...</p>}
        {selected && !loadingConv && (
          <>
            <div className={styles.soporteConvHeader}>
              <div>
                <p className={styles.soporteConvNombre}>{selected.asunto}</p>
                <p className={styles.soporteConvPartic}>
                  👥 {selected.participantes?.map(p => `${p.nombre} ${p.apellidos}`).join(', ')}
                </p>
              </div>
              <span className={styles.rolBadge} style={{'--rc':'#1a3a6b'}}>
                {selected.mensajes?.length} msg
              </span>
            </div>

            <div className={styles.soporteMensajes}>
              {mensajesConSep().map(item => {
                if (item.tipo === 'sep') {
                  return (
                    <div key={`sep-${item.clave}`} className={styles.fechaSepSop}>
                      <span className={styles.fechaSepTextoSop}>{etiquetaFechaSop(item.fecha)}</span>
                    </div>
                  );
                }
                const esAdmin = item.autor_rol === 'admin';
                return (
                  <div key={item.id} className={`${styles.soporteMsgRow} ${esAdmin ? styles.soporteMsgAdmin : styles.soporteMsgUser}`}>
                    <div className={`${styles.soporteBubble} ${esAdmin ? styles.soporteBubbleAdmin : styles.soporteBubbleUser}`}>
                      <p className={styles.soporteMsgAutor}>
                        {esAdmin ? '🎧 Soporte EduPortal' : `${item.autor_nombre} ${item.autor_apellidos}`}
                      </p>
                      {item.contenido && <p className={styles.msgTexto2}>{item.contenido}</p>}
                      {item.adjunto_nombre && (
                        /\.(png|jpg|jpeg|gif|webp)$/i.test(item.adjunto_nombre)
                          ? <img
                              src={abrirAdjunto(item.id, true)}
                              alt={item.adjunto_nombre}
                              className={styles.adjuntoImg}
                              onClick={() => window.open(abrirAdjunto(item.id, true), '_blank')}
                            />
                          : <button className={styles.adjuntoBtn}
                              onClick={() => window.open(abrirAdjunto(item.id, true), '_blank')}>
                              📎 {item.adjunto_nombre}
                            </button>
                      )}
                      <p className={styles.msgHora2}>{formatHora(item.created_at)}</p>
                    </div>
                  </div>
                );
              })}
              <div ref={endRef} />
            </div>

            <form onSubmit={enviar} className={styles.soporteResponderForm}>
              {adjunto && (
                <div className={styles.adjuntoPrevio}>
                  {/\.(png|jpg|jpeg|gif|webp)$/i.test(adjunto.name) ? '🖼️' : '📎'} {adjunto.name}
                  <button type="button" onClick={() => { setAdjunto(null); if (adjuntoRef.current) adjuntoRef.current.value = ''; }}>✕</button>
                </div>
              )}
              <div className={styles.responderRow}>
                <textarea
                  className={styles.responderInput}
                  placeholder="Responder como Soporte EduPortal... (Enter para enviar)"
                  value={respuesta} rows={2}
                  onChange={e => setRespuesta(e.target.value)}
                  onKeyDown={e => { if (e.key==='Enter' && !e.shiftKey) { e.preventDefault(); enviar(e); } }}
                />
                <input ref={adjuntoRef} type="file"
                  accept=".pdf,.doc,.docx,.txt,.zip,.png,.jpg,.jpeg,.gif,.webp"
                  style={{ display:'none' }}
                  onChange={e => setAdjunto(e.target.files[0] || null)}
                />
                <button type="button" className={styles.btnAdjunto}
                  onClick={() => adjuntoRef.current?.click()} title="Adjuntar archivo">📎</button>
                <button type="submit" className={styles.btnResponder}
                  disabled={enviando || (!respuesta.trim() && !adjunto)}>
                  {enviando ? '...' : '➤'}
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
